import { useCallback } from 'react'
import { useFetchRefactored } from 'civic-champs-shared/api/hooks'

export default function useResendGroupInvitations(refresh?: () => void) {
  const [request, { loading }] = useFetchRefactored({
    successMessage: 'Group invitation resent successfully',
    errorMessage: 'Error resending group invitation.',
    useNewNotification: true,
  })

  const resendInvitations = useCallback(
    (groupId: number, personIds: number[]) => {
      if (!personIds.length) {
        return Promise.resolve()
      }

      return request({
        method: 'post',
        url: `/groups/${groupId}/members/resend-invitations`,
        config: {
          body: { personIds },
        },
        onSuccess: () => refresh?.(),
      })
    },
    [request, refresh],
  )

  return { resendInvitations, loading }
}
